<template>
  <div class="google-map-display" ref="map"></div>
</template>

<script>
export default {
  props: {
    lat: Number,
    lon: Number,
    radius: Number,
    locked: {
      type: Boolean,
      default: false
    },
    zones: Array,
    show_zones: Boolean,
    show_marker: Boolean
  },
  data () {
    return {
      mapObject: null,
      marker: null,
      circle: null,
      zone_markers: [],
      zone_circles: []
    };
  },
  watch: {
    locked () {
      this.mapObject.setOptions({
        gestureHandling: this.locked ? "none" : "auto",
      });
    },
    'zones' () {
      this.rerender();
    },
    show_zones () {
      this.rerender();
    }
  },
  methods: {
    createMap () {
      const coords = new google.maps.LatLng(this.lat, this.lon);

      this.mapObject = new google.maps.Map(this.$refs.map, {
        zoom: 14,
        center: coords,
        gestureHandling: this.locked ? "none" : "auto"
      });

      let vm = this;

      google.maps.event.addListener(this.mapObject, "click", function (event) {
        console.log(event);
        vm.$emit("pin", {
          lat: event.latLng.lat(),
          lon: event.latLng.lng()
        });
      });
    },
    clearObjects () {
      this.zone_markers.forEach(m => m.setMap(null));
      this.zone_markers.length = 0;

      this.zone_circles.forEach(c => c.setMap(null));
      this.zone_circles.length = 0;

      if (this.marker) this.marker.setMap(null);
    },
    rerender () {
      this.clearObjects();

      if (this.show_zones) {
        this.zones.forEach((zone, index) => {
          const marker = new google.maps.Marker({
            position: {
              lat: zone.lat,
              lng: zone.lon
            },
            label: zone.name || `${index + 1}`,
            map: this.mapObject
          });

          const circle = new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
            map: this.mapObject,
            center: {
              lat: zone.lat,
              lng: zone.lon
            },
            radius: zone.radius,
          });

          this.zone_markers.push(marker);
          this.zone_circles.push(circle);
        });

        if (this.marker) this.marker.setMap(null);
      } else if (this.show_marker) {
        this.marker = new google.maps.Marker({
          position: {
            lat: this.lat,
            lng: this.lon
          },
          map: this.mapObject
        });
      }
    },
    onMapLocationChange (lat, lon) {
      let newLatLng = { lat: lat, lng: lon };

      this.circle.setCenter(newLatLng);

      this.marker.setPosition(newLatLng);

      // this.$emit("change", lat, lon);
    },
    onPositionChange () {
      this.onMapLocationChange(this.lat, this.lon);
    },
    onRadiusChange () {
      this.circle.setRadius(this.radius);
    }
  },
  mounted () {
    this.createMap();
    this.rerender();
  }
};
</script>

<style scoped>
.google-map-display {
  height: 40vh;
  border-radius: 0.8vh;
}
</style>